export default __webpack_public_path__ + "img/4.76f5359b.jpg";